<div class="page-main-header" [class.open]="open">
    <div class="main-header-right row">
        <div class="main-header-left d-lg-none col">
            <div class="logo-wrapper"><a [routerLink]="'/dashboard'"><img class="blur-up lazyloaded"
                        src="../../../../assets/images/logo1.png" alt=""></a></div>
        </div>
        <div class="mobile-sidebar col">
            <div class="media-body switch-sm">
                <label class="switch">
                    <a>
                        <app-feather-icons id="sidebar-toggle" [icon]="'align-left'" (click)="collapseSidebar()">
                        </app-feather-icons>
                    </a>
                </label>
            </div>
        </div>
        <div class="nav-right col">
            <ul class="nav-menus" [ngClass]="{'open' : openNav}">
                <li>
                    <form class="form-inline search-form">
                        <div class="form-group">
                            <input class="form-control-plaintext" [class.open]="isOpenMobile" type="search"
                                placeholder="Search..">
                            <span class="d-sm-none mobile-search">
                                <app-feather-icons [icon]="'search'" (click)="isOpenMobile=!isOpenMobile">
                                </app-feather-icons>
                            </span>
                        </div>
                    </form>
                </li>
                <li>
                    <a href="javascript:void(0)" class="text-dark" toggleFullscreen>
                        <app-feather-icons [icon]="'maximize-2'"></app-feather-icons>
                    </a>
                </li>
                <!-- Selector de modo -->
                <li class="onhover-dropdown mode-switcher" *ngIf="availableProfiles.length > 1">
                    <a href="javascript:void(0)" class="mode-trigger d-flex align-items-center gap-1">
                        <app-feather-icons [icon]="modeService.getActiveModeOption()?.icon || 'user'" class="mode-icon"></app-feather-icons>
                        <span class="mode-label d-none d-md-inline">{{ modeService.getActiveModeOption()?.shortLabel }}</span>
                        <app-feather-icons [icon]="'chevron-down'" class="mode-chevron"></app-feather-icons>
                    </a>
                    <ul class="profile-dropdown onhover-show-div p-10 mode-dropdown">
                        <li class="mode-header">
                            <small class="text-muted">Usar como:</small>
                        </li>
                        <li *ngFor="let opt of availableProfiles"
                            [class.active]="opt.value === activeMode"
                            (click)="switchMode(opt.value)">
                            <a href="javascript:void(0)" class="d-flex align-items-center gap-2">
                                <app-feather-icons [icon]="opt.icon"></app-feather-icons>
                                {{ opt.shortLabel }}
                                <app-feather-icons *ngIf="opt.value === activeMode" [icon]="'check'" class="ms-auto text-success check-icon"></app-feather-icons>
                            </a>
                        </li>
                    </ul>
                </li>
                <!-- <li class="onhover-dropdown"><a class="txt-dark" href="javascript:void(0)">
                        <h6>EN</h6>
                    </a>
                    <ul class="language-dropdown onhover-show-div p-20">
                        <li><a href="javascript:void(0)" data-lng="en"><i class="flag-icon flag-icon-is"></i>
                                English</a></li>
                        <li><a href="javascript:void(0)" data-lng="es"><i class="flag-icon flag-icon-um"></i>
                                Spanish</a></li>
                        <li><a href="javascript:void(0)" data-lng="pt"><i class="flag-icon flag-icon-uy"></i>
                                Portuguese</a></li>
                        <li><a href="javascript:void(0)" data-lng="fr"><i class="flag-icon flag-icon-nz"></i> French</a>
                        </li>
                    </ul>
                </li> -->
                <!-- <li class="onhover-dropdown">
                    
                    <app-feather-icons [icon]="'bell'"></app-feather-icons><span class="dot"></span>
                    <ul class="notification-dropdown onhover-show-div">
                        
                        <li>
                            <div class="media">
                                <div class="media-body">
                                    <h6 class="mt-0"><span>
                                            <app-feather-icons class="shopping-color" [icon]="'shopping-bag'">
                                            </app-feather-icons>
                                        </span>Your order ready for Ship..!
                                    </h6>
                                    <p class="mb-0">Lorem ipsum dolor sit amet, consectetuer.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="media">
                                <div class="media-body">
                                    <h6 class="mt-0 txt-success"><span>
                                            <app-feather-icons class="download-color font-success" [icon]="'download'">
                                            </app-feather-icons>
                                        </span>Download Complete</h6>
                                    <p class="mb-0">Lorem ipsum dolor sit amet, consectetuer.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="media">
                                <div class="media-body">
                                    <h6 class="mt-0 txt-danger"><span>
                                            <app-feather-icons class="alert-color font-danger" [icon]="'alert-circle'">
                                            </app-feather-icons>
                                        </span>250 MB trash files</h6>
                                    <p class="mb-0">Lorem ipsum dolor sit amet, consectetuer.</p>
                                </div>
                            </div>
                        </li>
                        <li class="txt-dark"><a href="javascript:void(0)">All</a> notification</li>
                    </ul>
                </li>
            -->   <li class="onhover-dropdown">
                    <div class="media align-items-center">
                        <img *ngIf="!profile?.imgProfile || !isValidImageUrl(profile?.imgProfile)" 
                             class="align-self-center pull-right img-50 rounded-circle"
                             src="assets/images/dashboard/man.png" 
                             alt="header-user" 
                             id="perfil">
                        <img *ngIf="profile?.imgProfile && isValidImageUrl(profile?.imgProfile)" 
                             class="align-self-center pull-right img-50 rounded-circle"
                             [src]="profile.imgProfile" 
                             alt="header-user"
                             (error)="onImageError($event)">

                        <div class="dotted-animation"><span class="animate-circle"></span><span
                                class="main-circle"></span></div>
                    </div>
                    <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                        <li><a [routerLink]="'/settings/profile'">
                                <app-feather-icons [icon]="'user'"></app-feather-icons>Perfil
                            </a></li>
                        <!-- <li><a href="javascript:void(0)">
                                <app-feather-icons [icon]="'mail'"></app-feather-icons>Inbox
                            </a></li>
                        <li><a href="javascript:void(0)">
                                <app-feather-icons [icon]="'lock'"></app-feather-icons>Lock Screen
                            </a></li> -->
                        <!-- <li>
                            <a href="javascript:void(0)">
                                <app-feather-icons [icon]="'settings'"></app-feather-icons>Settings
                            </a>
                        </li> -->
                        <li>
                            <a (click)="logOut()">
                                <app-feather-icons [icon]="'log-out'"></app-feather-icons>Cerrar sesión
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
            <div class="d-lg-none mobile-toggle pull-right" (click)="openMobileNav()">
                <app-feather-icons [icon]="'more-horizontal'"></app-feather-icons>
            </div>
        </div>
    </div>
</div>